import { WIDGET_TYPE_V2 } from '../common';
import { DateRageType } from '../../common/date';
import { BrandItemV2 } from '../../brand/list';
import { ValueOf } from '../../common/utils';
import { Attachment } from '../../../components/input/ImageAndVideoUploadV2/types';
import {
  BrandWidgetsCreateRequestWidgetDto,
  BrandWidgetsCreateRequestWidgetDtoLayoutTypeEnum,
  BrandWidgetsCreateRequestWidgetItemBrandDto,
  BrandWidgetsFindOneResponseWidgetDto,
} from '../../api/widgets';
import { WIDGET_EXPOSURE_PAGE_TYPE_V2 } from './common';

export const BRAND_WIDGET_LAYOUT_TYPE_V2 = {
  GRID_1X4: 'grid1x4',
  GRID_2X2: 'grid2x2',
  SCROLL_BLANK_NX1: 'scrollBlankNx1',
  SCROLL_NX1: 'scrollNx1',
  SWIPE: 'swipe',
} as const;

export type BRAND_WIDGET_LAYOUT_TYPE_V2 = ValueOf<typeof BRAND_WIDGET_LAYOUT_TYPE_V2>;

export type ExposureWidgetItemBrand = {
  id: number;
  title?: string;
  contents?: string;
  attachment?: Omit<Required<Attachment>, 'type'>[];
  brand: BrandItemV2;
};

export class BrandWidgetDetailV2 {
  type: typeof WIDGET_TYPE_V2.BRAND;
  layoutType: BRAND_WIDGET_LAYOUT_TYPE_V2;
  mainTitle: string;
  subTitle?: string;
  memo?: string;
  exposurePeriod: DateRageType;
  currentExposurePage?: string;
  widgetBrandList: BrandItemV2[];
  exposureWidgetItemBrands: ExposureWidgetItemBrand[];

  constructor(detail: BrandWidgetsFindOneResponseWidgetDto) {
    this.type = detail.type;
    this.layoutType = detail.layoutType;
    this.mainTitle = detail.mainTitle;
    this.subTitle = detail.subTitle;
    this.memo = detail.memo;
    this.exposurePeriod = {
      startDate: detail.exposureStartDate,
      endDate: detail.exposureEndDate,
    };
    this.currentExposurePage =
      detail.home?.type === WIDGET_EXPOSURE_PAGE_TYPE_V2.MAIN ? '메인 페이지' : detail.home?.title;
    this.widgetBrandList = detail.widgetItemBrands.map((item) => new BrandItemV2(item.brand));
    this.exposureWidgetItemBrands = detail.widgetItemBrands.map((item) => ({
      id: item.id,
      title: item.title,
      contents: item.contents,
      attachment: item.widgetItemBrandAttachment && [item.widgetItemBrandAttachment],
      brand: new BrandItemV2(item.brand),
    }));
  }
}

export class BrandWidgetRequestPayloadV2 implements BrandWidgetsCreateRequestWidgetDto {
  mainTitle: string;
  subTitle: string;
  memo: string;
  exposureStartDate: string | null;
  exposureEndDate: string | null;
  layoutType: BrandWidgetsCreateRequestWidgetDtoLayoutTypeEnum;
  widgetItemBrands: Array<BrandWidgetsCreateRequestWidgetItemBrandDto>;
  constructor(detail: BrandWidgetDetailV2) {
    this.mainTitle = detail.mainTitle;
    this.subTitle = detail.subTitle || '';
    this.memo = detail.memo || '';
    this.exposureStartDate = detail.exposurePeriod.startDate && new Date(detail.exposurePeriod.startDate).toISOString();
    this.exposureEndDate = detail.exposurePeriod.endDate && new Date(detail.exposurePeriod.endDate).toISOString();
    this.layoutType = detail.layoutType;
    this.widgetItemBrands = detail.exposureWidgetItemBrands.map((item) =>
      item.contents
        ? {
            brandId: item.brand.id,
            title: item.title || '',
            contents: item.contents,
            widgetItemBrandAttachment: item.attachment?.[0],
          }
        : { brandId: item.brand.id, title: item.title || '', widgetItemBrandAttachment: item.attachment?.[0] },
    );
  }
}
